// mian list for farm

export default [
    {
        id: "JGN/BNB",
        token_symbol: "JGN/BNB",
        item_icon: "jgn.png",
        item_icon_2: "bnb.png",
        token_address: "0x7275278C94b5e20708380561C4Af98F38dDC6374",
        //token_decimals: 18,
        token_earn_symbol: "JGN",
        // 合约地址
        // reward_address: "0x3311354798880eF029405c52BB275d10A69A9cde",
        reward_address: "0xf036C1226eafa96a2fE8933A52ac450AD171dAF4",
        apy: "-",
        start_time: {
          en: "10am, December 08, 2021 (EST)",
          zh: "2021年12月8号晚上10点"
        },
        des_earn_per_day: 8000,
        price_on_usd: 0.88,
      },
];